import { useCallback, useState } from 'react';

import { useHistory } from 'react-router-dom';

import { ITINERARIES_ITEM_TYPES, LIBRARY_ITINERARIES } from 'constants/index';
import { useItinerariesItemStepPath } from 'utils/itineraries/functions/useItinerariesItemStepPath';
import { GUEST_PORTAL_STEP_LIST } from 'utils/itineraries/guestPortal/map';

export const useEnterPortal = () => {
  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(0);

  function handlePageChange(page: number) {
    setCurrentPage(page);
  }

  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  return { itemsPerPage, currentPage, startIndex, endIndex, handlePageChange };
};

export const useEditGuestPortal = () => {
  const getGuestPortalPathStep = useItinerariesItemStepPath(ITINERARIES_ITEM_TYPES.GUEST_PORTAL);
  const history = useHistory();

  const handleEditGuestPortal = useCallback(
    (guestPortal: any) => {
      const step = guestPortal.lastAvailableStep ?? GUEST_PORTAL_STEP_LIST[0];
      history.push(
        getGuestPortalPathStep(step, guestPortal.id, {
          libType: LIBRARY_ITINERARIES,
        }),
        {
          from: history.location.pathname + history.location.search,
          libType: LIBRARY_ITINERARIES,
        },
      );
    },
    [getGuestPortalPathStep, history],
  );
  return { handleEditGuestPortal };
};
